


















































































































import {Component, Prop, Vue, Inject} from 'vue-property-decorator';
import FlexGridModel, {EditDialogsConfig} from '@/models/FlexGridModel';
import FlexGridHeaderSettingsDropdownMenu from '@/components/base/flex-grid/header/FlexGridHeaderSettingsDropdownMenu.vue';
import FlexGridDisplaySettings from '@/components/base/flex-grid/header/FlexGridDisplaySettings.vue';
import FlexGridImportSettings from '@/components/base/flex-grid/header/FlexGridImportSettings.vue';
import {cloneDeep} from 'lodash';
import FlexGridHeaderImportDialog from '@/components/base/flex-grid/header/FlexGridHeaderImportDialog.vue';
import FlexGridHeaderEditDialogsConfigDropdownMenu from '@/components/base/flex-grid/header/FlexGridHeaderEditDialogsConfigDropdownMenu.vue';
import {SET_TRANSPOSE} from '@/store/modules/flexGridModule/flexGrid-mutation-types';

/**
 * Flex grid header
 * @requires ./FlexGridHeaderSettingsDropdownMenu.vue
 * @requires ./FlexGridDisplaySettings.vue
 * @requires ./FlexGridImportSettings.vue
 * @requires ./FlexGridHeaderImportDialog.vue
 * @requires ./FlexGridHeaderEditDialogsConfigDropdownMenu.vue
 */
@Component({
    components: {
        FlexGridHeaderEditDialogsConfigDropdownMenu,
        FlexGridHeaderImportDialog,
        FlexGridImportSettings,
        FlexGridDisplaySettings,
        FlexGridHeaderSettingsDropdownMenu,
    },
})
export default class FlexGridHeader extends Vue {
    /**
     * Flex grid title
     */
    @Prop() title!: string;
    @Inject() moduleName!: string;
    @Inject() urlPath!: string;
    @Inject() urlQuery!: Object;
    @Inject() editDialogsConfig!: EditDialogsConfig | undefined;
    @Inject() commit!: Function;
    @Inject() selectable!: boolean;

    private exporting = false;
    private showSettingsTables = false;

    get mainData(): FlexGridModel | null {
        return this.$store.state[this.moduleName].data;
    }

    get isEditable(): number {
        return this.$store.state[this.moduleName].isEditable;
    }

    get compressed(): boolean {
        return this.$store.state[this.moduleName].compressed;
    }

    get showImportBtn() {
        return this.mainData?.Config.ShowImport;
    }

    get showImportSettings() {
        return this.mainData?.Config.ShowImport;
    }

    get isCanTranspose(): boolean {
        return this.$store.getters[`${this.moduleName}/isCanTranspose`];
    }

    get transpose(): boolean {
        return this.$store.state[this.moduleName].transpose;
    }

    async onExport() {
        if (this.exporting) return;
        this.exporting = true;
        try {
            const response = await this.$http.get(`${this.urlPath}/Export`, {
                params: {
                    ...this.urlQuery,
                },
                responseType: 'blob',
            });

            const cd = response.headers['content-disposition'];
            const fileName = cd.match(/filename=[\w]+\.[\w]+/gi)[0].replace('filename=', '');
            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = fileName;
            document.body.appendChild(link);

            setTimeout(function() {
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
            }, 4e4); // 40s

            setTimeout(function() {
                link.click();
            }, 0);
        } finally {
            this.exporting = false;
        }
    }

    onImport() {
        (this.$refs.importDialog as any).open(cloneDeep(this.mainData?.Config), {
            url: this.urlPath,
            query: this.urlQuery,
        });
    }

    onTranspose() {
        this.commit(SET_TRANSPOSE, true);
    }
}
